import { teamsClient } from '@atlassian/teams-client/client';
import { constructProductOriginParams } from '@atlassian/teams-common/urls';
import { TeamDiscoverability, TeamMembershipSettings, TeamPermission, TeamRestriction, TeamState } from '../types/team';
import { ErrorWithContext } from '../utils/error';
import { fetchJson, postJson } from '../utils/fetch';
const LIMIT_RESULTS = 5;
export const STARGATE = '/gateway/api';
export const STARGATE_ENDPOINT_TEAMS = `${STARGATE}/v3/teams`;
export const STARGATE_ENDPOINT_TEAMS_V4 = `${STARGATE}/v4/teams`;
export const STARGATE_ENDPOINT_TEAMS_OF = `${STARGATE_ENDPOINT_TEAMS}/of-user`;
export const STARGATE_ENDPOINT_TEAMS_SEACH = `${STARGATE_ENDPOINT_TEAMS_V4}/search`;
export const buildTeamsOfUrl = (userId, cloudId, product, tenantUrl = '', orgId) => {
  const params = [`limit=${LIMIT_RESULTS}`, 'cursor=', `organizationId=${orgId !== null && orgId !== void 0 ? orgId : ''}`, `origin.cloudId=${cloudId}`, `origin.product=${product.toUpperCase()}`];
  return `${tenantUrl}${STARGATE_ENDPOINT_TEAMS_OF}/${userId}?&${params.join('&')}`;
};
export const buildTeamsSearchUrl = (cloudId, product, tenantUrl = '') => `${tenantUrl}${STARGATE_ENDPOINT_TEAMS_SEACH}${constructProductOriginParams({
  product,
  cloudId
})}`;
export const fetchMyTeams = (userId, cloudId, product, tenantUrl = '', orgId) => orgId ? fetchJson(buildTeamsOfUrl(userId, cloudId, product, tenantUrl, orgId)) :
// If `orgId` is not present, just make this request hang forever as though loading.
new Promise(() => {});
export const searchTeamsOfUser = (userId, cloudId, product, tenantUrl = '', orgId) => {
  if (!userId || !cloudId || !orgId) {
    throw new ErrorWithContext('Missing parameters', {
      userId,
      cloudId,
      orgId,
      product,
      tenantUrl
    });
  }
  const url = buildTeamsSearchUrl(cloudId, product, tenantUrl);
  const postData = {
    organizationId: orgId,
    siteId: cloudId,
    limit: LIMIT_RESULTS,
    membership: {
      memberAccountIds: [userId]
    }
  };
  return postJson(url, postData);
};
export const postCreateTeam = async (teamName, membershipSettings, metaData) => {
  var _metaData$tenantUrl, _result$memberIds$len, _result$memberIds;
  teamsClient.setContext({
    cloudId: metaData.cloudId,
    orgId: metaData.orgId
  });
  teamsClient.setBaseUrl(`${(_metaData$tenantUrl = metaData.tenantUrl) !== null && _metaData$tenantUrl !== void 0 ? _metaData$tenantUrl : ''}${STARGATE}`);
  const result = await teamsClient.createTeam(teamName, {
    product: metaData.product
  }, [...new Set(metaData.members)], membershipSettings === TeamMembershipSettings.OPEN ? 'OPEN' : 'MEMBER_INVITE');
  return {
    id: result.id,
    displayName: result.displayName,
    description: result.description,
    state: result.state === 'ACTIVE' ? TeamState.ACTIVE : TeamState.PURGED,
    membershipSettings: result.membershipSettings === 'OPEN' ? TeamMembershipSettings.OPEN : TeamMembershipSettings.INVITE_ONLY,
    memberCount: (_result$memberIds$len = (_result$memberIds = result.memberIds) === null || _result$memberIds === void 0 ? void 0 : _result$memberIds.length) !== null && _result$memberIds$len !== void 0 ? _result$memberIds$len : 0,
    teamAri: `ari:cloud:teams::team/${result.id}`,
    discoverable: TeamDiscoverability.DISCOVERABLE,
    organizationId: result.organizationId,
    restriction: TeamRestriction.NO_RESTRICTION,
    creatorId: result.creatorId,
    permission: result.permission === 'FULL_WRITE' ? TeamPermission.FULL_WRITE : result.permission === 'FULL_READ' ? TeamPermission.FULL_READ : TeamPermission.NONE
  };
};
export const buildInviteTeamMembersUrl = (teamId, {
  product,
  cloudId,
  tenantUrl = ''
}) => {
  return `${tenantUrl}${STARGATE_ENDPOINT_TEAMS}/ui/${teamId}/membership/invite${constructProductOriginParams({
    product,
    cloudId
  })}`;
};
export const postInviteTeamMembers = async (teamId, users, metaData) => {
  if (!users || users.length === 0) {
    return Promise.resolve(undefined);
  }
  const emails = [];
  const ids = [];
  users.forEach(user => {
    if (user.id) {
      ids.push(user.id);
    } else if (user.email) {
      emails.push(user.email);
    }
  });
  const url = buildInviteTeamMembersUrl(teamId, metaData);
  const postData = {
    emailAddresses: emails,
    atlassianAccounts: ids
  };
  return postJson(url, postData);
};